import React, { Component } from 'react';
import { Row, Col, Card, CardBody, ListGroup, ListGroupItemHeading, ListGroupItem, Button } from 'reactstrap';
import './style.scss';
import { getNewsFeeds, searchCounterpartyName, submitNewsFeed } from "./action";
import { connect } from 'react-redux';
import AsyncSelect from 'react-select/async';
import CorporateModal from '../../components/UI/CorporateModal'
import { MODAL_TYPE_FORM, MODAL_TYPE_SUCCESS, MODAL_TYPE_FAILURE } from "../../constants";


class NewsModerationComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filter: '',
            inputValue: '',
            asyncCallback: null,
            values: [],
            selectedValues: [],
            newsFeedsData: {
                content: []
            },
            newsFeedsCountPerPage: 5,
            defaultPage: 0,
            showModal: false,
            modalType: MODAL_TYPE_FORM,
            modalCloseHandler: () => { },
            modalTitle: '',
            body: ''
        }
    }

    componentDidMount = () => {
        this.props.getNewsFeeds(this.state.defaultPage, this.state.newsFeedsCountPerPage);
    }

    componentDidUpdate = (prevProps) => {
        if (prevProps.searchCounterpartyDataSuccess !== this.props.searchCounterpartyDataSuccess) {
            let options = this.props.searchCounterpartyDataSuccess.map((el) => {
                el.label = el.counterpartyName + " (" + el.city + ")";
                el.value = el.id;
                return el;
            });

            this.setState({
                values: options
            })

            if (this.state.asyncCallback) {
                this.state.asyncCallback(options);
            }
        }
        if (prevProps.newsFeedsData !== this.props.newsFeedsData) {
            this.setState({
                newsFeedsData: this.props.newsFeedsData
            })
        }

    }

    toggleModal = () => {
        this.setState(prevState => ({
            showModal: !prevState.showModal,
            body: null
        }))
    }

    handleCounterpartyChange = (newValue, callback) => {
        const inputValue = newValue.replace(/\W/g, '');
        this.setState({
            inputValue,
            asyncCallback: callback
        });
        this.props.searchCounterpartyName(inputValue)
        return inputValue;
    };
    defaultOptions = (type, elem) => {
        elem.map((el) => {
            el.value = el.id;
            if (type === 'cp') {
                el.label = el.counterpartyName + " (" + el.city + ")";
            } else {
                el.label = el.keyword
            }
        })
        return elem;
    }

    counterpartyChangeHandler = (id, selectedCp, action) => {
        let updatedNewsFeedData = Object.assign({}, this.state.newsFeedsData);

        let newsItemToBeUpdated = updatedNewsFeedData.content.find((item) => { return item.id === id });
        newsItemToBeUpdated.approvedCounterparties = selectedCp;
    }

    keywordChangeHandler = (selectedKw, action) => {
        this.setState(prevState => ({
            newsFeedsData: {
                ...prevState.newsFeedsData,
                approvedKeywords: selectedKw
            }
        }));
    }    

    asyncSelectNoOptionMessage = (inputValue) => {
        return "Type something...";
    }


    submitNewsItem = (newsId) => {
        let newsItemToBeSubmitted = this.state.newsFeedsData.content.find((item) => { return item.id === newsId });
        if (newsItemToBeSubmitted.approvedCounterparties.length === 0) {
            this.setState({
                body: <div className="text-center news-feed-message">
                    <i className="d-block text-secondary icon-alert"></i>
                    &nbsp;&nbsp;
                    <label>Atleast one counterparty should be selected !!!</label>
                </div>,
                showModal: true,
                modalType: MODAL_TYPE_FAILURE,
                modalTitle: 'No Counterparty Selected !!!',
                modalCloseHandler: this.toggleModal
            })
        } else {
            this.props.submitNewsFeed(newsItemToBeSubmitted, this.state.defaultPage, this.state.newsFeedsCountPerPage);
            this.setState({
                body: <div className="text-center news-feed-message">
                    <i className="d-block text-success icon-check"></i>
                    &nbsp;&nbsp;
                    <label>Approved successfully !!!</label>
                </div>,
                showModal: true,
                modalType: MODAL_TYPE_SUCCESS,
                modalTitle: 'APPROVED !!!',
                modalCloseHandler: this.toggleModal
            })
        }
    }

    dismissNewsItem = (newsId) => {
        let newsItemToBeSubmitted = this.state.newsFeedsData.content.find((item) => { return item.id === newsId });
        newsItemToBeSubmitted.approvedCounterparties = [];
        newsItemToBeSubmitted.approvedKeywords = [];
        this.props.submitNewsFeed(newsItemToBeSubmitted, this.state.defaultPage, this.state.newsFeedsCountPerPage);
        this.setState({
            body: <div className="text-center news-feed-message">
                <i className="d-block text-secondary icon-alert"></i>
                &nbsp;&nbsp;
                <label>News feed dismissed !!!</label>
            </div>,
            showModal: true,
            modalType: MODAL_TYPE_SUCCESS,
            modalTitle: 'DISMISSED !!!',
            modalCloseHandler: this.toggleModal
        })
    }

    showNextPageFeeds = () => {
        let pageNumber = this.state.defaultPage;
        pageNumber++;
        this.setState({
            defaultPage: pageNumber
        })
        this.props.getNewsFeeds(pageNumber, this.state.newsFeedsCountPerPage)
    }

    showPrevPageFeeds = () => {
        let pageNumber = this.state.defaultPage;
        pageNumber--;
        this.setState({
            defaultPage: pageNumber
        })
        this.props.getNewsFeeds(pageNumber, this.state.newsFeedsCountPerPage)
    }

    render() {
        return (
            <Col>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h4 className="mb-0">
                        News Moderation
                    </h4>
                </div>
                <Card className="mb-70">
                    <CardBody className="news-feed-moderation">
                        <ListGroup className="p-0">
                            {this.state.newsFeedsData.content.map(news => {
                                return (
                                    <ListGroupItem className="rounded mb-4 p-3" key={news.id}>
                                        <ListGroupItemHeading className="p-0 text-capitalize mb-3 text-dark">
                                            <p className="news-feed-moderation-title">{news.feedDetails.title}</p>
                                        </ListGroupItemHeading>
                                        <p className="news-feed-moderation-description">
                                            {news.feedDetails.description} <a href={news.feedDetails.link} target="_blank" className="ml-3" rel="noreferrer">Read More</a>
                                        </p>
                                        <div>
                                            <Row className="mb-3 d-flex align-items-center">
                                                <Col xs="4" className="text-dark">Counterparty Name : </Col>
                                                <Col xs="20">
                                                    <AsyncSelect
                                                        isMulti
                                                        cacheOptions
                                                        closeMenuOnSelect={false}
                                                        defaultOptions={this.state.values}
                                                        noOptionsMessage={this.asyncSelectNoOptionMessage}
                                                        defaultValue={this.defaultOptions('cp', news.approvedCounterparties)}
                                                        loadOptions={this.handleCounterpartyChange}
                                                        onChange={(selectedCp, action) => this.counterpartyChangeHandler(news.id, selectedCp, action)}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row className="mb-3">
                                                <Col xs="4" className="text-dark">Keywords : </Col>
                                                <Col xs="20">
                                                    <AsyncSelect
                                                        isMulti
                                                        cacheOptions
                                                        closeMenuOnSelect={false}
                                                        defaultOptions={this.state.values}
                                                        noOptionsMessage={this.asyncSelectNoOptionMessage}
                                                        defaultValue={this.defaultOptions('keyword', news.approvedKeywords)}
                                                        onChange={this.keywordChangeHandler}
                                                        isDisabled = {true}
                                                    />
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col xs="4" className="offset-4 d-flex">
                                                    <Button color="secondary" onClick={() => this.dismissNewsItem(news.id)} className="ml-auto d-flex mr-3" type="button">Dismiss</Button>
                                                    <Button color="primary" onClick={() => this.submitNewsItem(news.id)} className="ml-auto d-flex" type="button">Approve</Button>
                                                </Col>
                                            </Row>
                                        </div>

                                    </ListGroupItem>
                                )
                            })}
                        </ListGroup>
                        <Card className="position-fixed news-feed-pagination">
                            <CardBody className="w-100">
                                <div className="w-75 m-auto d-flex justify-content-center align-items-center">
                                    <Button onClick={this.showPrevPageFeeds} disabled={this.state.defaultPage === 0} color="primary" outline>Prev</Button>
                                    <div className="px-3">
                                        <span>Page {this.state.defaultPage + 1} </span>
                                        <span> of </span>
                                        <span>{this.state.newsFeedsData.totalPages}</span>
                                    </div>
                                    <Button onClick={this.showNextPageFeeds} disabled={this.state.defaultPage + 1 === this.state.newsFeedsData.totalPages} color="primary" outline>Next</Button>
                                </div>
                            </CardBody>
                        </Card>
                    </CardBody>
                </Card>
                <CorporateModal toShow={this.state.showModal}
                    modalClosed={this.state.modalCloseHandler}
                    modalType={this.state.modalType}
                    body={this.state.body}
                    title={this.state.modalTitle} />
            </Col>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        newsFeedsData: state.newsFeeds.newsFeedsSuccess,
        searchCounterpartyDataSuccess: state.newsFeeds.searchCounterpartyResults,
        submitNewsFeedSuccess: state.newsFeeds.submitNewsFeedSuccess
    }
}
const mapDispatchToProps = (dispatch, props) => {
    return {
        getNewsFeeds: (pageCount, newsFeedsPerPage) => dispatch(getNewsFeeds(pageCount, newsFeedsPerPage)),
        searchCounterpartyName: (val) => dispatch(searchCounterpartyName(val)),
        submitNewsFeed: (data, pageCount, newsFeedsPerPage) => dispatch(submitNewsFeed(data, pageCount, newsFeedsPerPage))
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(NewsModerationComponent);
